import { Box, Flex, Spinner, Switch } from '@chakra-ui/react';
import { Button, SectionLabel } from '@kula-ai/components';
import { Edit05, Stars03 } from '@kula-ai/icons-core';
import { KText } from '@/ui-library/components/text';
import { SCHEDULE_AI_COPY } from '../../constants';
import { ReadOnlyDetails } from './ReadOnlyDetails';
import { EditableDetails } from './EditableDetails';
import { mapPlanInterviewerToAsyncSelectOption } from '../hooks/scheduleWithAiForm.pure';

const COPY = SCHEDULE_AI_COPY;

const LOCATIONS_WITH_NOTE_TAKER = ['google_meet', 'zoom', 'teams'];

export const InterviewDetailsSection = ({
  showInterviewDetailsAsEditable,
  isPlanLoading,
  displayPlan,
  interviewName,
  setInterviewName,
  planInterviewers,
  selectedInterviewers,
  setSelectedInterviewers,
  setIsInterviewDetailsEditing,
  interviewKind,
  setInterviewKind,
  durationMinutes,
  setDurationMinutes,
  location,
  setLocation,
  officeId,
  setOfficeId,
  offices,
  isOfficeLoading,
  calendarVisibility,
  setCalendarVisibility,
  availableLocations,
  noteTakerEnabled,
  setNoteTakerEnabled,
  noteTakerMandatory = false,
  officeAddressFieldRef,
  calendarAvailabilityById,
}) => (
  <>
    <Box mb="20px">
      <Box mb="12px">
        <SectionLabel
          trailing={
            !showInterviewDetailsAsEditable ? (
              <Button
                type="button"
                variant="tertiary"
                size="regular"
                fontWeight="medium"
                leftElement={<Edit05 size={14} />}
                onClick={() => {
                  setIsInterviewDetailsEditing(true);
                  if (planInterviewers.length === 0) return;
                  if (selectedInterviewers.length === 0) {
                    setSelectedInterviewers(
                      planInterviewers.map(
                        mapPlanInterviewerToAsyncSelectOption
                      )
                    );
                    return;
                  }
                  setSelectedInterviewers(
                    selectedInterviewers.map((sel) => {
                      const fromPlan = planInterviewers.find(
                        (p) => p.id === sel.value
                      );
                      return fromPlan
                        ? mapPlanInterviewerToAsyncSelectOption(fromPlan)
                        : sel;
                    })
                  );
                }}
              >
                {COPY.editInterview}
              </Button>
            ) : null
          }
        >
          {COPY.interviewDetailsLabel}
        </SectionLabel>
      </Box>
      {isPlanLoading ? (
        <Flex justify="center" py="24px">
          <Spinner size="sm" color="primary-500" />
        </Flex>
      ) : showInterviewDetailsAsEditable ? (
        <EditableDetails
          interviewName={interviewName}
          setInterviewName={setInterviewName}
          interviewKind={interviewKind}
          setInterviewKind={setInterviewKind}
          selectedInterviewers={selectedInterviewers}
          setSelectedInterviewers={setSelectedInterviewers}
          durationMinutes={durationMinutes}
          setDurationMinutes={setDurationMinutes}
          location={location}
          setLocation={setLocation}
          officeId={officeId}
          setOfficeId={setOfficeId}
          offices={offices}
          isOfficeLoading={isOfficeLoading}
          calendarVisibility={calendarVisibility}
          setCalendarVisibility={setCalendarVisibility}
          availableLocations={
            availableLocations?.locations ?? availableLocations
          }
          officeAddressFieldRef={officeAddressFieldRef}
        />
      ) : (
        <ReadOnlyDetails
          plan={displayPlan}
          interviewName={interviewName}
          calendarAvailabilityById={calendarAvailabilityById}
        />
      )}
    </Box>

    {showInterviewDetailsAsEditable &&
      LOCATIONS_WITH_NOTE_TAKER.includes(location) && (
        <Box mb="20px">
          <Flex
            bg="#F8F7FA"
            borderRadius="12px"
            p="18px 16px"
            gap="10px"
            flexDir="column"
          >
            <Flex justifyContent="space-between" alignItems="center">
              <Flex gap="10px" alignItems="center">
                <Stars03 size={20} color="#6D659D" />
                <KText size="sm-semi-bold" color="primary-700">
                  {COPY.enableNoteTaker}
                </KText>
              </Flex>
              <Box
                flexShrink={0}
                position="relative"
                sx={{ pointerEvents: 'auto' }}
              >
                <Switch
                  className={`ats-switch-toogle schedule-ai-note-taker-switch ${noteTakerEnabled || noteTakerMandatory ? 'active' : ''}`}
                  colorScheme="ats-primary"
                  isChecked={noteTakerEnabled || noteTakerMandatory}
                  isDisabled={noteTakerMandatory}
                  onChange={(e) => setNoteTakerEnabled(e.target.checked)}
                  cursor={noteTakerMandatory ? 'not-allowed' : 'pointer'}
                />
              </Box>
            </Flex>
            <KText size="sm-regular" color="primary-900">
              {COPY.enableNoteTakerDescription}
            </KText>
          </Flex>
        </Box>
      )}
  </>
);
